/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import './auth.css';
import { OtpSignUp } from './OtpSignUp';
import { Register } from './Register';

export function Login() {
  const [showLogin, setShowLogin] = useState(true);
  const [userData, setUserData] = useState({});

  const handleComplete = (userDataRes) => {
    setShowLogin(false);
    setUserData(userDataRes);
  };
  return (
    <div className=''>
      {/* <div className='header w-100'>
        <div className='header-container'>
          {!showLogin && <img className='login_header_logo' src={'img/edraak_logo.png'} />}
        </div>
      </div> */}
      <div className='main_panel container d-flex' style={{ flex: 1 }}>
        <div className='row justify-content-center '>
          <div className='col-md-8 text-left'>
            <h1 className='main_login_headding'>Welcome to a whole new learning experience.</h1>
            <p className='main_login_sub_headding text-left'>
              Edraak Learning Solutions helps you active your goals in an easy & effective manner.
            </p>
            <img className='login_main_image' src={'img/loginframe.png'} />
          </div>
          {showLogin && (
            <div className='col-md-4 pt-5 pb-5'>
              <img className='login_main_logo' src={'img/edraak_logo.png'} />
              <OtpSignUp handleComplete={handleComplete} />
            </div>
          )}
          {!showLogin && (
            <div className='col-md-4  pb-5 registercontainer'>
              <Register user={userData} />
            </div>
          )}
        </div>
      </div>
      <div className='footer  w-100'>
        <div className='footer-container  d-flex justify-content-between align-items-center'>
          <img className='login_header_logo' src={'img/edraak_logo.png'} />
          <div className='policies'>
            <a href='https://edraakonline.com/terms-and-condition/' className='policy'>
              Terms of Use
            </a>
            <a href='https://edraakonline.com/privacy-policy/' className='policy'>
              Privacy Policy
            </a>
            <a href='https://edraakonline.com/cancellation-and-refund-policy/' className='policy'>
              Cancel & Refund
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
